import { createFileRoute } from '@tanstack/react-router'
import { AllShiftsPage } from '@/features/scheduler/pages/all-shifts-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/scheduler/all-shifts'
)({
  component: AllShiftsPage,
})
